/**
 * vee - Стандартные ошибки vee-validate
 * laravel_rules - это локализация для ошибок laravel, которых нет в vee-validate
 * custom_rules - Ошибки валидации для созданных правил для vee-validate
 */

const defaultError = 'Поле {_field_} имеет недопустимое значение';
const vee = require('vee-validate/dist/locale/ru').messages;
const custom_rules = {
  phone: defaultError,
  ip: 'Поле {_field_} должно быть действительным IP адресом',
  prefix: 'Поле {_field_} может содержать только цифры и #',
  pbx_internal_number: 'Поле {_field_} уже существует',
  latin_num: 'Поле {_field_} может содержать только латинский алфавит и цифры',
  latin_num_ext:
    'Поле {_field_} может содержать только латинский алфавит, цифры и специальные символовы (.,-_).',
  login: 'Поле {_field_} может содержать только латинский алфавит, цифры и подчеркивания',
  accepted: 'Вы должны принять {_field_}.',
  oneOf: 'Поле {_field_} должно быть допустимым значением ({values})',
  mimes: 'Поле {_field_} должно иметь допустимый тип файла. ({values})',
  ext: 'Поле {_field_} должно быть действительным файлом. ({values})',
  password: `Пароль должен содержать заглавную и строчную латинские буквы, а также цифры.`,
  sms_count: 'Для кодировки {encoding} установлен лимит символов: {max_symbol_count}',
  url_ip: 'Поле имеет ошибочный формат',
  old_date: 'Дата должна быть позже текущей',
  check_current_password: 'Текущий пароль указан неверно',
  password_regex: '',
  need_scheme: 'Требуется создать схему'
};

const laravel_rules = {
  accepted: 'Вы должны принять {_field_}',
  active_url: 'Поле {_field_} должно быть действительным URL адресом',
  after: 'В поле {_field_} должна быть дата после {date}',
  after_or_equal: 'В поле {_field_} должна быть дата после или равняться {date}',
  array: 'Поле {_field_} должно быть массивом',
  before: 'В поле {_field_} должна быть дата до {date}',
  before_or_equal: 'В поле {_field_} должна быть дата до или равняться {date}',
  boolean: 'Поле {_field_} должно иметь значение логического типа',
  confirmed: 'Поле {_field_} не совпадает с подтверждением',
  date: 'Поле {_field_} не является датой',
  date_equals: 'Поле {_field_} должно быть датой равной {date}',
  date_format: 'Поле {_field_} не соответствует формату {format}',
  different: 'Поле {_field_} должно отличаться от поля {other}',
  digits_between: 'Длина цифрового поля {_field_} должна быть между {min} и {max}',
  dimensions: 'Поле {_field_} имеет недопустимые размеры изображения',
  distinct: 'Поле {_field_} содержит повторяющееся значение',
  ends_with: 'Поле {_field_} должно заканчиваться одним из следующих значений: {values}',
  exists: 'Выбранное значение {_field_} некорректно',
  file: 'Поле {_field_} должно быть файлом',
  filled: 'Поле {_field_} обязательно для заполнения',
  image: 'Поле {_field_} должно быть изображением',
  in_array: 'Поле {_field_} не существует в {other}',
  ipv4: 'Поле {_field_} должно быть действительным IPv4-адресом',
  ipv6: 'Поле {_field_} должно быть действительным IPv6-адресом',
  json: 'Поле {_field_} должно быть JSON строкой',
  not_in: 'Выбранное значение для {_field_} ошибочно',
  not_regex: vee.regex,
  present: 'Поле {_field_} должно присутствовать',
  required_if: 'Поле {_field_} обязательно для заполнения, когда {other} равно {value}',
  required_recipient: 'Поле {_field_} обязательно для заполнения',
  required_unless: 'Поле {_field_} обязательно для заполнения, когда {other} не равно {values}',
  required_with: 'Поле {_field_} обязательно для заполнения, когда {values} указано',
  required_with_all: 'Поле {_field_} обязательно для заполнения, когда {values} указано',
  required_without: 'Поле {_field_} обязательно для заполнения, когда {values} не указано',
  required_without_all:
    'Поле {_field_} обязательно для заполнения, когда ни одно из {values} не указано',
  same: 'Значения поля {_field_} должно совпадать с {other}',
  starts_with: 'Поле {_field_} должно начинаться из одного из следующих значений: {values}',
  string: 'Поле {_field_} должно быть строкой',
  timezone: 'Поле {_field_} должно быть действительным часовым поясом',
  unique: 'Такое значение поля {_field_} уже существует',
  url: 'Поле {_field_} имеет ошибочный формат',
  uuid: 'Поле {_field_} должно быть корректным UUID',
};

/**
 * Из документации
 * The field under validation must have a size matching the given value.
 * For string data, value corresponds to the number of characters.
 * For numeric data, value corresponds to a given integer value.
 * For an array, size corresponds to the count of the array.
 * For files, size corresponds to the file size in kilobytes.
 *
 * В vee-validate это разные правила min/max min_value/max_value, length.
 * Если понадобится - нужно перенести эти правила в vee-validate. Но пока отображаем только текст
 */
const size_laravel_rules = {
  between: {
    numeric: 'Поле {_field_} должно быть между {min} и {max}',
    file: 'Размер файла в поле {_field_} должен быть между {min} и {max} Килобайт(а)',
    string: 'Количество символов в поле {_field_} должно быть между {min} и {max}',
    array: 'Количество элементов в поле {_field_} должно быть между {min} и {max}'
  },
  gt: {
    numeric: 'Поле {_field_} должно быть больше {size}',
    file: 'Размер файла в поле {_field_} должен быть больше {size} Килобайт(а)',
    string: 'Количество символов в поле {_field_} должно быть больше {size}',
    array: 'Количество элементов в поле {_field_} должно быть больше {size}'
  },
  gte: {
    numeric: 'Поле {_field_} должно быть больше или равно {size}',
    file: 'Размер файла в поле {_field_} должен быть больше или равен {size} Килобайт(а)',
    string: 'Количество символов в поле {_field_} должно быть больше или равно {size}',
    array: 'Количество элементов в поле {_field_} должно быть больше или равно {size}'
  },
  lt: {
    numeric: 'Поле {_field_} должно быть меньше {size}',
    file: 'Размер файла в поле {_field_} должен быть меньше {size} Килобайт(а)',
    string: 'Количество символов в поле {_field_} должно быть меньше {size}',
    array: 'Количество элементов в поле {_field_} должно быть меньше {size}'
  },
  lte: {
    numeric: 'Поле {_field_} должно быть меньше или равно {size}',
    file: 'Размер файла в поле {_field_} должен быть меньше или равен {size} Килобайт(а)',
    string: 'Количество символов в поле {_field_} должно быть меньше или равно {size}',
    array: 'Количество элементов в поле {_field_} должно быть меньше или равно {size}'
  },
  max: {
    numeric: 'Поле {_field_} не может быть более {size}',
    file: 'Размер файла в поле {_field_} не может быть более {size} Килобайт(а)',
    string: 'Количество символов в поле {_field_} не может превышать {size}',
    array: 'Количество элементов в поле {_field_} не может превышать {size}'
  },
  min: {
    numeric: 'Поле {_field_} должно быть не менее {size}',
    file: 'Размер файла в поле {_field_} должен быть не менее {size} Килобайт(а)',
    string: 'Количество символов в поле {_field_} должно быть не менее {size}',
    array: 'Количество элементов в поле {_field_} должно быть не менее {size}'
  },
  size: {
    numeric: 'Поле {_field_} должно быть равным {size}',
    file: 'Размер файла в поле {_field_} должен быть равен {size} Килобайт(а)',
    string: 'Количество символов в поле {_field_} должно быть равным {size}',
    array: 'Количество элементов в поле {_field_} должно быть равным {size}'
  }
};

const custom_laravel_rules = {
  sip_account_with_caller_id_limit: 'Вы не можете создать более {size} sip-аккаунтов с caller_id',
  action_link: 'Вы не можете создать связь',
  action_menu: 'Вы не можете создать более {size} IVR-меню',
  client_config_record_outgoing: 'Запись звонка недоступна для этого пакета',
  contact_limit: 'Вы не можете создать более {size} контактов',
  contact_method_limit: 'Вы не можете создать более {size} контакт-методово',
  entry_point_record_type: 'Запись звонка недоступна для этого пакета',
  sms_verification: 'Ошибка SMS подтверждения',
  check_balance: 'Недостаточно средств',
  change_package_limit: 'Пакет услуг АТС можно изменить только один раз в сутки'
};

export const rules = Object.assign({}, vee, custom_rules, laravel_rules, custom_laravel_rules, {
  laravel: size_laravel_rules
});
